import {REPURPOSE_ACTION_LABELS} from '../locales';

import type {Action} from '@netx/core/bootstrap';

import {icon} from '@fortawesome/fontawesome-svg-core';
import {faRecycle} from '@fortawesome/pro-solid-svg-icons';

import {permissionsEnabled} from '@netx/core-permissions-next/enablers';
import {UserLevel} from '@netx/core-user-next/constants';
const permissionsV2Enabled = permissionsEnabled();

const iconOpts = {classes: ['fa-fw']};
const icons = {
	faRecycle: icon(faRecycle, iconOpts).html,
};

export const REPURPOSE_ACTION_ICON = <const>{
	REPURPOSE: faRecycle,
};

export type RepurposeBaseVent = typeof REPURPOSE_BASE_EVENT;

export const REPURPOSE_BASE_EVENT = `asset:repurpose`;

export const REPURPOSE_EVENT = <const>{
	REPURPOSE_ASSET: `${REPURPOSE_BASE_EVENT}:asset`,
	REPURPOSE_SELECTION: `${REPURPOSE_BASE_EVENT}:seleciton`,
	REPURPOSE_AUDIO: `${REPURPOSE_BASE_EVENT}:audio`,
	REPURPOSE_IMAGE: `${REPURPOSE_BASE_EVENT}:image`,
};

export const REPURPOSE_ACTIONS: Action<
	(typeof REPURPOSE_EVENT)[keyof typeof REPURPOSE_EVENT]
>[] = [
	{
		event: REPURPOSE_EVENT.REPURPOSE_ASSET,
		icon: icons.faRecycle,
		get label() {
			return REPURPOSE_ACTION_LABELS.REPURPOSE;
		},
		userLevel: permissionsV2Enabled ? undefined : UserLevel.CONSUMER,
	},
	{
		event: REPURPOSE_EVENT.REPURPOSE_SELECTION,
		icon: icons.faRecycle,
		get label() {
			return REPURPOSE_ACTION_LABELS.REPURPOSE;
		},
		userLevel: permissionsV2Enabled ? undefined : UserLevel.CONSUMER,
	},
];

export default REPURPOSE_ACTIONS;
